import { fetchJSON, fetchWithAuth } from "../util/fetch-utils";
export default class VelavuAPIAPITokens {
    //This method returns all tokens associated with a customer account.
    getAllTokens() {
        return fetchJSON("/tokens");
    }
    //This method creates a new authentication token.
    createNewToken(params) {
        return fetchJSON("/tokens", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(params),
        });
    }
    //This method deletes an authentication token
    deleteToken(tokenID) {
        return fetchWithAuth(`/tokens/${tokenID}`, { method: "DELETE" });
    }
}
//# sourceMappingURL=velavu-api-api-tokens.js.map